<template>
  <div class="dashboard-page container-page">
    <ConnectKiovietComponent v-if="!connected" @connected="loadStatus" />
    <KiovietTabComponent v-if="connected" @disconnected="loadStatus" />
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import {AppConstant} from "@/supports/app.constant.ts";
  import {useSyncKiotviet} from "@/stores/syncKiotviet.js";
  import {useAccountStore} from "@/stores/account.js";
  const syncKiotvietStore = useSyncKiotviet();
  const connected = ref(false);
  const accountStore = useAccountStore();
  import ConnectKiovietComponent from './connects/ConnectKiovietComponent.vue';
  import KiovietTabComponent from './show-tabs/KiovietTabComponent.vue';
  const loadStatus = async () => {
      const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-kiotviet/status';
      const params = {
        m_company_id: accountStore.account.company.id,
      }
      const data = await syncKiotvietStore.status(url, params);
      connected.value = data.length > 0;
  };

  onMounted(loadStatus);
</script>